module.exports = "/assets/data/f472cdb8e289e7d64d8961802c9c05a7-SR2.data.json";